import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import domainSlice from './slices/domainSlice';


export const store = configureStore({
  reducer: {
    auth: authSlice,
    domain: domainSlice,
  },
});